// src\themes\lino\components\Banner.tsx
'use client';

import Image from "next/image";
import Link from "next/link";
import { motion } from "motion/react";
import { BannerData } from "@/core/types/about-us";
import { loadThemeComponent } from "@/core/config/theme-component-loader";
import { textGroupVariants, textItemVariants } from "./animations/textReveal";
const CustomButton = loadThemeComponent("CustomButton")

interface BannerProps {
  data: BannerData;
}

export default function Banner({ data }: BannerProps) {

  return (
    <div className="col-span-12 relative w-full h-72 lg:h-96 flex items-end p-7 lg:p-14 overflow-hidden rounded-2xl">
      {data.image && (
        <Image
          src={data.image?.url}
          alt={data.title || "some picture"}
          className="absolute w-full h-full object-cover"
          fill
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/55 via-primary-950/5 to-transparent z-0" />
      <motion.div
        className="relative space-y-4 max-w-md"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.4 }}
        variants={textGroupVariants}
      >
        {data.title && (
          <motion.h2 variants={textItemVariants} className="text-primary-0 text-2xl lg:text-3xl tracking-tight font-light leading-[1.15]">
            {data.title}
          </motion.h2>
        )}
        {data?.description && (
          <motion.p variants={textItemVariants} className="text-primary-0/80 text-[13px] leading-7">
            {data.description}
          </motion.p>
        )}
        {(data.buttonContent && data.link) && (
          <motion.div variants={textItemVariants} className="w-fit">
            <CustomButton variant="transparentWhite" size="sm" asChild>
              <Link href={data.link}>{data.buttonContent}</Link>
            </CustomButton>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
}